import { FC, useState,useEffect } from "react";
import { HeaderView } from "./HeaderView";
import { HeaderViewMobile } from "./HeaderViewMobile";
import { appConfig } from '../../AppConfig';
import { switchThemeModeAction } from "../../store/actions/themeModeActions";
import { useConfirm } from '../../Contexts/hooks';
import { useTranslation } from 'react-i18next';
import { logout } from '../../Security/azureAdAuthentication';
import { usePromptToInstall } from '../../Contexts/PromptToInstallContext';
import { useUserContext } from '../../Contexts/UserContext';
import { UserInteractionEventProperties, EventName_UserInteraction, EventProperty_Value_ApplicationType, EventProperty_Value_ReleaseNotesClick } from '../../store/models/customEvents';
import { IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { appInsights } from '../../AppInsights';
import { useTheme,useGptConfigurations } from '../../store/hooks';
import { WIKI_URLS } from '../../constants/wikiUrls';

export interface HeaderHandlerProps {
     // onMenuToggle now expects the desired open state
    onMenuToggle?: (open: boolean) => void;
    onNewChat?: (gptConfiguration: IGptConfiguration) => void;
    isMenuOpen?: boolean;
    isMobile?: boolean;
}
const HeaderHandler: FC<HeaderHandlerProps> = (props: HeaderHandlerProps) => {

    const { onMenuToggle, onNewChat = () => console.warn("onNewChat handler not provided"), isMenuOpen, isMobile } = props;

    const { userProfile } = useUserContext();
    const { t } = useTranslation();
    const { themeMode, dispatch: themeModeDispatch } = useTheme();
    const confirm = useConfirm();
    const getEnvironmentLabel = (): string | undefined => {
        switch (appConfig.ENVIRONMENT) {
            case 'local':
                return 'LOCAL';
            case 'development':
                return 'DEV';
            case 'test':
                return 'TEST';
            case 'preprod':
                return 'PRE-PROD';
            default:
                return undefined;
        }
    };

    const handleLogout = () => {
        confirm({
            show: true,
            title: t('settings.logout.title', 'Log out of SyGPT'),
            message: t('settings.logout.confirm', 'Are you sure you want to log out?'),
            confirmText: t('Yes', 'Yes'),
            cancelText: t('Cancel', 'Cancel'),
        }).then(() => {
            logout();
        });
    };    // Create a wrapper function for the translation function to match expected signature
    const translationWrapper = (key: string, defaultValue?: string) => {
        return t(key, defaultValue || key);
    };

    const { gptConfigurations } = useGptConfigurations();
    const [defaultGpt, setDefaultGpt] = useState<IGptConfiguration>();

    useEffect(() => {
        setDefaultGpt(gptConfigurations.filter(gpt => gpt.isDefault)[0]);
    }, [gptConfigurations]);
    
    const onNewChatClick = () => {
        console.log("HeaderHandler onNewChatClick");
        console.log("onNewChat function:", typeof onNewChat);
        console.log("defaultGpt:", defaultGpt);
        console.log("available gptConfigurations:", gptConfigurations?.length);
        
        if (!onNewChat) {
            console.error("onNewChat function is not provided");
            return;
        }
        
        if (defaultGpt) {
            console.log("Calling onNewChat with defaultGpt");
            onNewChat(defaultGpt);
        } else if (gptConfigurations && gptConfigurations.length > 0) {
            console.log("Using first available GPT configuration");
            onNewChat(gptConfigurations[0]);
        } else {
            console.warn("No GPT configuration available for new chat");
        }
    };

const onVersionNumberClick = () => {
        appInsights.trackEvent({
            name: EventName_UserInteraction,
            properties: {
                applicationType: EventProperty_Value_ApplicationType,
                userId: userProfile?.username,
                interactionType: EventProperty_Value_ReleaseNotesClick
            } as UserInteractionEventProperties,
        });
        window.open(WIKI_URLS.RELEASE_NOTES, '_blank');
    };

    const onToggleThemeMode = () => {
        themeModeDispatch(switchThemeModeAction());
    };
    const { state, deferredEvt } = usePromptToInstall();
    const handleInstallApp = () => {
        if (state === 'installed') {
            confirm({
                show: true,
                title: t('header.SyGPTInstall.title', 'Install SyGPT on your desketop'),
                message: t('header.SyGPTInstall.SyGPTInstalled', 'SyGPT is already installed as a desktop app'),
                confirmText: t('Close', 'Close'),
            });
        } else if (state === 'not-supported') {
            confirm({
                show: true,
                title: t('header.SyGPTInstall.title', 'Install SyGPT on your desketop'),
                message: t('header.SyGPTInstall.SyGPTInstallNotSupported', 'Your browser does not support installing web apps'),
                confirmText: t('Close', 'Close'),
            });
        } else if (deferredEvt && state === 'supported') {
            deferredEvt.prompt();
        }
    };

    return   isMobile ? ( 
        <HeaderViewMobile
        onMenuToggle={onMenuToggle}
        onNewChatClick={onNewChatClick}
        isMenuOpen={isMenuOpen}
        onToggleTheme={onToggleThemeMode}
        themeMode={themeMode}
        handleLogout={handleLogout}
        handleInstallApp={handleInstallApp}
        userPhoto={userProfile?.photo}
        />
        ) : (
        <HeaderView
        onMenuToggle={onMenuToggle}
        onNewChatClick= {onNewChatClick}
        onVersionNumberClick={onVersionNumberClick}
        isMenuOpen={isMenuOpen}
        environmentName={getEnvironmentLabel()}
        onToggleTheme={onToggleThemeMode}
        themeMode={themeMode}
        handleInstallApp={handleInstallApp}
        handleLogout={handleLogout}
        userName={userProfile?.name}
        userPhoto={userProfile?.photo}
        />
    );
}

export default HeaderHandler;